/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * ########################################
 * Collapse Space between Headline and Sub
 * ########################################
 */
jQuery(document).ready(function($) {

    $('.sub').prev('h1', 'h2', 'h3', 'h4', 'h5', 'h6').addClass('mb-0');

});

